import { ReactNode } from "react";

type IcoName =
  | "camera" | "doc" | "chat" | "store" | "pin" | "clock"
  | "phone" | "truck" | "mobile" | "bell" | "receipt" | "tank";

interface IcoProps {
  name: IcoName;
  c?: string;
  s?: number;
}

/** 入口流程用的線性圖示（沿用原型 SVG） */
const Ico = ({ name, c = "#2196f3", s = 22 }: IcoProps) => {
  const p: Record<IcoName, ReactNode> = {
    camera: <><rect x="3" y="7" width="18" height="13" rx="2" stroke={c} strokeWidth="1.8" /><path d="M8 7l1.5-2.5h5L16 7" stroke={c} strokeWidth="1.8" strokeLinejoin="round" /><circle cx="12" cy="13" r="3.4" stroke={c} strokeWidth="1.8" /></>,
    doc: <><rect x="5" y="3" width="14" height="18" rx="2" stroke={c} strokeWidth="1.8" /><path d="M9 8h6M9 12h6M9 16h4" stroke={c} strokeWidth="1.8" strokeLinecap="round" /></>,
    chat: <path d="M4 5h16a1 1 0 011 1v10a1 1 0 01-1 1H8l-4 4V6a1 1 0 011-1z" stroke={c} strokeWidth="1.8" strokeLinejoin="round" />,
    store: <><path d="M4 9l1-4h14l1 4M5 9v10h14V9M4 9h16" stroke={c} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /><path d="M9 19v-5h6v5" stroke={c} strokeWidth="1.8" /></>,
    pin: <><path d="M12 21s7-6 7-11a7 7 0 10-14 0c0 5 7 11 7 11z" stroke={c} strokeWidth="1.8" /><circle cx="12" cy="10" r="2.5" stroke={c} strokeWidth="1.8" /></>,
    clock: <><circle cx="12" cy="12" r="9" stroke={c} strokeWidth="1.8" /><path d="M12 7v5l3 2" stroke={c} strokeWidth="1.8" strokeLinecap="round" /></>,
    phone: <path d="M5 4h3l1.5 4-2 1.5a11 11 0 005 5l1.5-2 4 1.5V17a2 2 0 01-2 2A14 14 0 015 6a2 2 0 012-2z" fill={c} />,
    truck: <><rect x="3" y="7" width="11" height="9" rx="1" stroke={c} strokeWidth="1.8" /><path d="M14 10h4l3 3v3h-7" stroke={c} strokeWidth="1.8" strokeLinejoin="round" /><circle cx="7" cy="18" r="1.6" stroke={c} strokeWidth="1.8" /><circle cx="17" cy="18" r="1.6" stroke={c} strokeWidth="1.8" /></>,
    mobile: <><rect x="7" y="3" width="10" height="18" rx="2" stroke={c} strokeWidth="1.8" /><path d="M11 18h2" stroke={c} strokeWidth="1.8" strokeLinecap="round" /></>,
    bell: <><path d="M6 9a6 6 0 1112 0c0 5 2 6 2 6H4s2-1 2-6z" stroke={c} strokeWidth="1.8" strokeLinejoin="round" /><path d="M10 19a2 2 0 004 0" stroke={c} strokeWidth="1.8" /></>,
    receipt: <><path d="M6 3h12v18l-2-1.5L14 21l-2-1.5L10 21l-2-1.5L6 21z" stroke={c} strokeWidth="1.8" strokeLinejoin="round" /><path d="M9 8h6M9 12h6" stroke={c} strokeWidth="1.8" strokeLinecap="round" /></>,
    tank: <><rect x="7" y="7" width="10" height="14" rx="3.5" stroke={c} strokeWidth="1.8" /><rect x="10" y="3" width="4" height="4" rx="1" stroke={c} strokeWidth="1.8" /><path d="M9 14h6" stroke={c} strokeWidth="1.6" strokeLinecap="round" /></>,
  };
  return <svg width={s} height={s} viewBox="0 0 24 24" fill="none">{p[name]}</svg>;
};

export default Ico;

/** 共用資訊 icon（白色 i） */
export const infoIcon = (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke="#fff" strokeWidth="2" />
    <path d="M12 11v5M12 8h.01" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
